<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="['Members', name]"></ch-breadcrumb>
  <p *ngIf="memberLoadFailed" role="status">Member details are unavailable. Reload the page to try again.</p>
  <form *ngIf="memberDataLoaded" (ngSubmit)="edit(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-9 col-md-9 pr-5">
          <div class="card mb-9">
            <div class="card-header">Member details</div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <p>
                      <b>Subscription info</b>
                    </p>
                    <div>
                      <label for="member-edit-name">Subscription Status:</label>
                      <b>{{
                        memberData.subscriptionStatus
                        ? memberData.subscriptionStatus.replaceAll("_", " ")
                        : "none"
                        }}</b>
                    </div>
                    <div>
                      <label for="member-edit-name">Subscription End Date:</label>
                      <b>{{
                        memberData.subscriptionEndsAt | dateFormat: "datetime"
                        }}</b>
                    </div>
                    <div>
                      <label for="member-edit-name">Subscription Name:</label>
                      <b>{{ memberData.subscriptionName || "none" }}</b>
                      <span *ngIf="memberData.billingCycleChange && memberData.billingCycleChange.pending"
                        class="label label-warning" style="margin-left: 8px; vertical-align: middle; cursor: help"
                        [title]="billingCycleChangeTooltip">
                        Changing
                      </span>
                    </div>
                    <div>
                      <label for="member-edit-name">Stripe Customer ID:</label>
                      <b>
                        <a *ngIf="memberData.customerId; else noCustomerId" [href]="stripeCustomerLink" target="_blank">
                          {{ memberData.customerId }}
                        </a>
                        <ng-template #noCustomerId> none </ng-template>
                      </b>
                    </div>
                    <div>
                      <label for="member-edit-name">Current Subscription ID:</label>
                      <b>
                        <a *ngIf="memberData.currentSubscriptionId; else noCurrentSubscriptionId"
                          [href]="stripeSubscriptionLink" target="_blank">
                          {{ memberData.currentSubscriptionId }}
                        </a>
                        <ng-template #noCurrentSubscriptionId> none </ng-template>
                      </b>
                    </div>
                    <div>
                      <label for="member-edit-name">Current Promo Code Name:</label>
                      <b>{{ memberData.promoCodeName || "none" }}</b>
                    </div>
                    <div>
                      <label for="member-edit-name">Current Promo Code:</label>
                      <b>{{ memberData.promoCode || "none" }}</b>
                    </div>
                    <div>
                      <label for="member-edit-name">Introductory Trial Period:</label>
                      <b>
                        {{
                        memberData.introductoryTrialPeriod
                        ? memberData.introductoryTrialPeriod
                        : "0"
                        }}
                        {{
                        memberData.introductoryTrialPeriod === 1
                        ? "day"
                        : "days"
                        }}
                      </b>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <p>
                      <b>Member info</b>
                    </p>
                    <div>
                      <label for="member-edit-name">Code:</label>
                      <b>{{ memberData.codeId }}</b>
                    </div>
                    <div>
                      <label for="member-edit-referrer-id">Referrer ID:</label>
                      <b>
                        <a *ngIf="memberData.referrerId; else noReferrerId" [href]="referrerProfileLink"
                          target="_blank">
                          {{ memberData.referrerId }}
                        </a>
                        <ng-template #noReferrerId> none </ng-template>
                      </b>
                    </div>
                    <div>
                      <label for="member-edit-name">Member Status:</label>
                      <b>{{
                        memberData.status
                        ? memberData.status.replaceAll("_", " ")
                        : ""
                        }}</b>
                    </div>
                    <div>
                      <label for="member-edit-name">Registration Status:</label>
                      <b>{{
                        memberData.registrationStatus
                        ? memberData.registrationStatus.replaceAll("_", " ")
                        : "Completed"
                        }}</b>
                    </div>
                    <div>
                      <label for="member-edit-name">Proof of Employment Status:</label>
                      <b>{{
                        memberData.proofOfEmploymentStatus
                        ? memberData.proofOfEmploymentStatus.replaceAll(
                        "_",
                        " "
                        )
                        : "Completed"
                        }}</b>
                    </div>
                    <div style="display: flex; gap: 8px" class="mt-2">
                      <button id="memberWebProfileButton" type="button" class="btn btn-default"
                        (click)="toggleWebProfileDialog()">
                        Web Profile
                      </button>
                      <button id="memberAbTestsButton" type="button" class="btn btn-default"
                        (click)="toggleAbTestsDialog()">
                        AB Tests
                      </button>
                      <button id="memberDevicesButton" type="button" class="btn btn-default"
                        (click)="toggleDevicesDialog()">
                        Tokens
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="member-edit-name">Name</label>

                <div class="row ch-member-names">
                  <div class="col-md-6">
                    <input type="text" class="form-control" [(ngModel)]="memberData.firstName" name="firstName"
                      #firstName="ngModel" class="form-control" id="member-edit-name" required [readonly]="loading" />
                  </div>
                  <div class="col-md-6">
                    <input type="text" class="form-control" [(ngModel)]="memberData.lastName" name="lastName"
                      #lastName="ngModel" class="form-control" id="member-edit-name" required [readonly]="loading" />
                  </div>
                </div>

                <small class="text-danger" *ngIf="
                    (firstName.touched ||
                      firstName.dirty ||
                      lastName.touched ||
                      lastName.dirty) &&
                    (!firstName.valid || !lastName.valid)
                  ">
                  Name is invalid.
                </small>
              </div>
              <div class="form-group">
                <label for="member-edit-date-of-birth">Date of Birth</label>
                <input type="date" class="form-control" [(ngModel)]="memberData.dateOfBirth" name="dateOfBirth" #dateOfBirth="ngModel"
                  class="form-control" id="member-edit-date-of-birth" [readonly]="loading" />
                <small class="text-danger" *ngIf="(dateOfBirth.touched || dateOfBirth.dirty) && !dateOfBirth.valid">
                  Date of birth is invalid.
                </small>
              </div>
              <div *ngIf="loaded">
                <ch-member-email-settings [memberId]="memberId" [emailAddresses]="memberData.emailAddresses" [disabled]="loading"
                  (primaryChanged)="memberData.email = $event"
                  (unavailableChanged)="emailUnavailable = $event"
                  (requestFailed)="showEmailRequestError($event)"></ch-member-email-settings>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-4">
                    <label for="member-edit-country">Country</label>
                    <input type="text" class="form-control" [(ngModel)]="memberData.country" name="country"
                      #country="ngModel" class="form-control" id="member-edit-country" [readonly]="loading" />
                    <small class="text-danger" *ngIf="
                        (country.touched || country.dirty) && !country.valid
                      ">
                      Country is invalid.
                    </small>
                  </div>
                  <div class="col-md-4">
                    <label for="member-edit-city">City</label>
                    <input type="text" class="form-control" [(ngModel)]="memberData.city" name="member-edit-city"
                      #city="ngModel" class="form-control" id="member-edit-city" [readonly]="loading" />
                    <small class="text-danger" *ngIf="(city.touched || city.dirty) && !city.valid">
                      City is invalid.
                    </small>
                  </div>
                  <div class="col-md-4">
                    <label for="member-edit-zip">ZIP Code</label>
                    <input type="text" class="form-control" [(ngModel)]="memberData.zipCode" name="member-edit-zip"
                      #zipCode="ngModel" class="form-control" id="member-edit-city" [readonly]="loading" />
                    <small class="text-danger" *ngIf="
                        (zipCode.touched || zipCode.dirty) && !zipCode.valid
                      ">
                      ZIP code is invalid.
                    </small>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="member-edit-job-title">Aquisition Channel</label>
                <div class="form-check">
                  <input id="aChannelOptionYes" type="radio" name="acquisitionChannel" [value]="'DISCOUNT'"
                    [(ngModel)]="memberData.acquisitionChannel" #e1="ngModel" />
                  <label class="form-check-label" for="aChannelOptionYes">Referred</label>
                </div>
                <div class="form-check">
                  <input id="aChannelOptionNo" type="radio" name="acquisitionChannel" [value]="'STAFF_INCENTIVE'"
                    [(ngModel)]="memberData.acquisitionChannel" [disabled]="!isValidAc" #e2="ngModel" />
                  <label class="form-check-label" for="aChannelOptionNo">Staff subscription</label>
                </div>
              </div>

              <div class="form-group">
                <label for="member-edit-job-title">Job Title</label>
                <select id="member-edit-job-title" class="form-control" [(ngModel)]="selectedJobTitleId"
                  name="jobTitle" #jobTitle="ngModel" required [disabled]="loading">
                  <option value=""></option>
                  <option *ngFor="let jt of jobTitles" [value]="jt.id">
                    {{ jt.name }}
                  </option>
                </select>
                <small class="text-danger" *ngIf="!loading && (jobTitle.touched || jobTitle.dirty) && !jobTitle.valid">
                  Job Title is invalid.
                </small>
              </div>

              <div class="form-group">
                <label for="member-edit-management-level">Management Level</label>
                <select id="member-edit-management-level" class="form-control" [(ngModel)]="selectedManagementLevelId"
                  name="managementLevel" #managementLevel="ngModel" [disabled]="loading">
                  <option value=""></option>
                  <option *ngFor="let ml of managementLevels" [value]="ml.id">
                    {{ ml.name }}
                  </option>
                </select>
                <small class="text-danger" *ngIf="!loading && (managementLevel.touched || managementLevel.dirty) && !managementLevel.valid">
                  Management Level is invalid.
                </small>
              </div>

              <div class="form-group">
                <label for="member-edit-area-of-business">Area of Business</label>
                <select id="member-edit-area-of-business" class="form-control" [(ngModel)]="selectedAreaOfBusinessId"
                  name="areaOfBusiness" #areaOfBusiness="ngModel" [disabled]="loading">
                  <option value=""></option>
                  <option *ngFor="let aoe of areasOfBusiness" [value]="aoe.id">
                    {{ aoe.name }}
                  </option>
                </select>
                <small class="text-danger" *ngIf="!loading && (areaOfBusiness.touched || areaOfBusiness.dirty) && !areaOfBusiness.valid">
                  Area of Business is invalid.
                </small>
              </div>

              <div class="form-group">
                <label for="member-edit-employer">Employer</label>
                <select id="member-edit-employer" class="form-control" [(ngModel)]="memberData.employer"
                  name="employer" #employer="ngModel" required [disabled]="loading" (change)="onEmployerChange()">
                  <option value=""></option>
                  <option value="__OTHER__">Other (not listed)</option>
                  <option *ngFor="let name of employerNames" [value]="name">
                    {{ name }}
                  </option>
                </select>
                <small class="text-danger" *ngIf="!loading && (employer.touched || employer.dirty) && !employer.valid">
                  Employer is invalid.
                </small>
                <div *ngIf="showCustomEmployer" class="mt-2">
                  <label for="member-edit-custom-employer">Employer name</label>
                  <input type="text" class="form-control" id="member-edit-custom-employer"
                    [(ngModel)]="customEmployer" name="customEmployer" #customEmployerInput="ngModel"
                    required [readonly]="loading" />
                  <small class="text-muted">Please enter the employer's full name</small>
                  <small class="text-danger" *ngIf="(customEmployerInput.touched || customEmployerInput.dirty) && !customEmployerInput.valid">
                    Employer name is required.
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label for="member-notes">Notes</label>
                <ch-wysiwyg [value]="memberData.notes" (onChange)="currentNotes = $event"
                  id="offer-description-input"></ch-wysiwyg>
              </div>

              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input id="referrals-enabled-flag-checkbox" (change)="
                      markReferralsEnabledFlag(referralsEnabledFlagCh.checked)
                    " #referralsEnabledFlagCh type="checkbox" name="referralsEnabledFlag"
                    [(ngModel)]="memberData.referralsEnabledFlag" class="custom-control-input" />
                  <label class="custom-control-label" for="referrals-enabled-flag-checkbox">Is part of
                    Refer-A-Friend?</label>
                </div>
              </div>

              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input id="profile-completion-flag-checkbox" type="checkbox" name="updateNewRegistrationFieldsEnabledFlag"
                    [(ngModel)]="memberData.updateNewRegistrationFieldsEnabledFlag" class="custom-control-input" />
                  <label class="custom-control-label" for="profile-completion-flag-checkbox">Require profile completion?</label>
                </div>
              </div>

              <div class="form-group">
                <label for="member-edit-job-title">Proof of employment</label>
                <div class="row">
                  <div class="col-sm-4 col-md-4" *ngIf="memberData.proofResourceId">
                    <ch-image-view *ngIf="
                        memberData.proofResourceIsImage;
                        else proofDownload
                      " [resourceId]="memberData.proofResourceId"></ch-image-view>
                    <ng-template #proofDownload>
                      <button id="memberEditProofDownload" type="button" (click)="downloadProof()"
                        class="btn btn-primary normal" [disabled]="loading">
                        Download
                      </button>
                    </ng-template>
                  </div>
                  <div class="col-sm-8 col-md-8">
                    <div class="proof-item" *ngIf="showButtons && memberData.proofResourceId">
                      <ch-loading-button id="memberEditProofApprove" (onClick)="approve()" text="Approve"
                        className="btn btn-primary normal" [loading]="approving"
                        [disabled]="loading"></ch-loading-button>
                      <button id="memberEditProofReject" type="button" (click)="reject()" class="btn btn-danger"
                        [disabled]="loading">
                        Reject
                      </button>
                    </div>
                    <div class="proof-item" *ngIf="isAccepted">
                      Accepted at:
                      {{ memberData.lastStatusUpdate | dateFormat }}
                    </div>
                    <div class="proof-item" *ngIf="isRejected">
                      <ch-loading-button (onClick)="approve()" text="Approve" className="btn btn-primary normal"
                        [loading]="approving" [disabled]="loading"></ch-loading-button>
                      Rejected at:
                      {{ memberData.lastStatusUpdate | dateFormat }}
                    </div>
                    <div class="proof-item">
                      <button id="memberEditProofRequest" type="button" (click)="showNewIdModal = !showNewIdModal"
                        class="btn btn-info" [disabled]="loading">
                        Request New ID
                      </button>
                      <ch-new-id-notification-modal-dialog [show]="showNewIdModal" (close)="showNewIdModal = false"
                        (submit)="requestNewId($event)"></ch-new-id-notification-modal-dialog>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" style="margin-top: 40px">
                <div class="col-sm-12" *ngIf="hasActiveSubscription">
                  <p id="memberDeleteDisclaimer" class="alert alert-info">
                    This member has an active subscription. Cancel all active subscriptions before deleting the member.
                  </p>
                </div>
                <div class="col-sm-2">
                  <button id="memberEditDelete" type="button" class="btn btn-danger"
                    (click)="toggleMemberDeleteDialog()" [disabled]="loading || hasActiveSubscription"
                    [attr.aria-describedby]="hasActiveSubscription ? 'memberDeleteDisclaimer' : null">
                    Delete
                  </button>
                </div>
                <div class="col-sm-7">
                  <div class="row">
                    <div class="col-sm-12">
                      <button id="memberEditSuspendAction" type="button" class="btn btn-warning" (click)="suspend()"
                        [disabled]="loading">
                        {{ isSuspended ? "Unsuspend" : "Suspend" }}
                      </button>
                      <button id="memberEditResetPassword" type="button" class="btn btn-info"
                        (click)="resetPassword(emailUnavailable || emailSettings?.primaryDirty)"
                        [disabled]="loading || emailUnavailable || emailSettings?.primaryDirty">
                        Reset Password
                      </button>
                      <button id="memberEditMakeVIP" type="button" *ngIf="!memberData.isVip" class="btn btn-primary"
                        (click)="makeVip()">
                        Make VIP
                      </button>
                      <button id="memberEditRevokeVIP" type="button" *ngIf="memberData.isVip" class="btn btn-primary"
                        (click)="revokeVip()">
                        Revoke VIP
                      </button>
                      <button id="memberEditAddSubscription" type="button" class="btn btn-info" *ngIf="
                          !(
                            'ACTIVE_SUBSCRIPTION' ==
                            memberData.subscriptionStatus
                          )
                        " (click)="addSubscription()">
                        Add subscription
                      </button>
                      <button id="memberEditCancelSubscription" type="button" *ngIf="
                          'ACTIVE_SUBSCRIPTION' == memberData.subscriptionStatus
                        " class="btn btn-primary" (click)="toggleCancelMemberDialog()">
                        Cancel Subscription
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col btn-container-right text-right">
                  <button id="memberEditCancel" type="button" class="btn btn-secondary" (click)="cancel()"
                    [disabled]="loading">
                    Cancel
                  </button>
                  <button id="memberEditSave" type="submit" class="btn btn-primary" [disabled]="loading || emailUnavailable">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3 col-md-3">
          <div class="card mb-9">
            <div class="card-header">Statistics</div>
            <div class="card-body">
              <div class="panel-info">
                <p *ngIf="!loaded">...</p>
                <div *ngIf="loaded">
                  <div class="card card-inverse card-important bg-primary" style="margin-bottom: 15px">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.viewsCount }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Offer Views
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary" style="margin-bottom: 15px">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.redemptionsCount }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Redemptions
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary" style="margin-bottom: 15px">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ referrals.pendingReferrals }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Pending Referrals
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary" style="margin-bottom: 15px">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ referrals.successfulReferrals.length }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Successful Referrals
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary" style="margin-bottom: 15px">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.lastLogin | dateFormat }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Last Login
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary" style="margin-bottom: 15px">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.createdAt | dateFormat }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          CODE Profile Created
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary" style="margin-bottom: 15px">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.lastOfferRedeemedAt | dateFormat }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Last Redemption
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.yearsOfSubscription }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Years of subscription
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.approvedAt | dateFormat }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Approval date
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.freeTrialStartsAt | dateFormat }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Free trial start date
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.freeTrialEndsAt | dateFormat }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Free trial end date
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.subscriptionStartsAt | dateFormat }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Paid subscription start date
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.subscriptionEndsAt | dateFormat }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Paid subscription renewal date
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.currentSubscriptionStartDate | dateFormat }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Current Subscription - Started
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.currentPeriodStart | dateFormat }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Current Period Start
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.currentPeriodEnd | dateFormat }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Current Period End
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.paidCustomerSince | dateFormat }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Paid Customer Since
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none">
                        <div class="display-6 font-weight-bold">
                          {{ memberData.customerCreatedAt | dateFormat }}
                        </div>
                        <div class="text-uppercase font-weight-bold">
                          Customer Since
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-12">
          <div class="card mb-9">
            <div class="card-header">Successful Referrals</div>
            <div class="card-body">
              <div class="table-responsive">
                <div class="loading-cont" *ngIf="loading">
                  <div class="loading-spinner"></div>
                </div>
                <p class="no-items-found" *ngIf="!loading && 0 === referrals.successfulReferrals.length">
                  No successful referrals.
                </p>

                <table class="table table-hover" *ngIf="!loading && 0 < referrals.successfulReferrals.length">
                  <thead>
                    <tr>
                      <th>
                        <span class="col-name">Referee ID</span>
                      </th>
                      <th>
                        <span class="col-name">Stripe Subscription ID</span>
                      </th>
                      <th>
                        <span class="col-name">Created At</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="
                        let item of referrals.successfulReferrals;
                        let i = index
                      ">
                      <td>
                        <a [href]="refereeProfileLink(item)" target="_blank">
                          {{ item.refereeId }}
                        </a>
                      </td>
                      <td>
                        <a [href]="refereeStripeSubscriptionLink(item)" target="_blank">
                          {{ item.stripeSubscriptionId }}
                        </a>
                      </td>
                      <td>
                        <span>{{ item.createdAt | dateFormat }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-12">
          <div class="card mb-9">
            <div class="card-header">Referral Rewards</div>
            <div class="card-body">
              <div class="table-responsive">
                <div class="loading-cont" *ngIf="loading">
                  <div class="loading-spinner"></div>
                </div>
                <p class="no-items-found" *ngIf="!loading && 0 === rewardInstances.length">
                  No reward instances.
                </p>

                <table class="table table-hover" *ngIf="!loading && 0 < rewardInstances.length">
                  <thead>
                    <tr>
                      <th>
                        <span class="col-name">Reward ID</span>
                      </th>
                      <th>
                        <span class="col-name">Created At</span>
                      </th>
                      <th>
                        <span class="col-name">Redeemed At</span>
                      </th>
                      <th>
                        <span class="col-name">Expired At</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of rewardInstances; let i = index">
                      <td>
                        <a [href]="rewardInstanceLink(item)" target="_blank">
                          {{ item.referralRewardId }}
                        </a>
                      </td>
                      <td>
                        <span>{{ item.createdAt | dateFormat }}</span>
                      </td>
                      <td>
                        <span>
                          {{
                          item.redeemedAt
                          ? (item.redeemedAt | dateFormat)
                          : ""
                          }}
                        </span>
                      </td>
                      <td>
                        <span>
                          {{
                          item.expiredAt ? (item.expiredAt | dateFormat) : ""
                          }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-12">
          <div class="card mb-9">
            <div class="card-header">Referral Reward Progress</div>
            <div class="card-body">
              <div class="table-responsive">
                <div class="loading-cont" *ngIf="loading">
                  <div class="loading-spinner"></div>
                </div>
                <p class="no-items-found" *ngIf="!loading && 0 === referrals.rewardProgress.length">
                  No reward instances.
                </p>

                <table class="table table-hover" *ngIf="!loading && 0 < referrals.rewardProgress.length">
                  <thead>
                    <tr>
                      <th>
                        <span class="col-name">Program ID</span>
                      </th>
                      <th>
                        <span class="col-name">Reward ID</span>
                      </th>
                      <th>
                        <span class="col-name">Type</span>
                      </th>
                      <th>
                        <span class="col-name">Existing Referrals Count</span>
                      </th>
                      <th>
                        <span class="col-name">Required Referrals Count</span>
                      </th>
                      <th>
                        <span class="col-name">Max Redemptions Per Member</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of referrals.rewardProgress; let i = index">
                      <td>
                        <a [href]="programLink(item)" target="_blank">
                          {{ item.programId }}
                        </a>
                      </td>
                      <td>
                        <a [href]="rewardLink(item)" target="_blank">
                          {{ item.rewardId }}
                        </a>
                      </td>
                      <td>
                        <span>{{ item.type }}</span>
                      </td>
                      <td>
                        <span>{{ item.existingReferralsCount }}</span>
                      </td>
                      <td>
                        <span>{{ item.requiredReferralsCount }}</span>
                      </td>
                      <td>
                        <span>{{ item.maxRedemptionsPerMember }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-12">
          <div class="card mb-9">
            <div class="card-header">Event Log</div>
            <div class="card-body">
              <div class="panel-info">
                <p *ngIf="!loaded">...</p>
                <div *ngIf="loaded">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Timestamp</th>
                          <th>Description</th>
                          <th>Issuer</th>
                          <th>Details</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let event of events">
                          <td>{{ event.type }}</td>
                          <td>
                            {{ event.createdAt.format("HH:mm DD MMM YYYY") }}
                          </td>
                          <td>{{ event.description }}</td>
                          <td style="word-break: normal">{{ event.issuer }}</td>
                          <td>{{ event.parsedDetails }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<ch-web-profile-modal-dialog [show]="showWebProfileModal" [memberId]="memberId"
  (close)="closeWebProfileDialog()"></ch-web-profile-modal-dialog>

<ch-ab-tests-modal-dialog [show]="showAbTestsModal" [memberId]="memberId"
  (onClose)="closeAbTestsDialog()"></ch-ab-tests-modal-dialog>

<ch-devices-modal-dialog [show]="showDevicesModal" [memberId]="memberId"
  (close)="closeDevicesDialog()"></ch-devices-modal-dialog>

<ch-add-subscription-modal-dialog [show]="showSubscriptionModal" (onAdd)="onSubscriptionAdded($event)"
  (onClose)="onSubscriptionDialogClosed()"></ch-add-subscription-modal-dialog>

<ch-cancel-subscription-modal-dialog [show]="showCancelMemberModal" [showEndOfPeriod]="memberData.subscriptionEndsAt"
  (onSubmitEndOfPeriodCancellation)="cancelSubscriptionEndOfPeriod($event)"
  (onSubmitImmediateCancellation)="cancelSubscriptionNow($event)" (onClose)="closeCancelMemberDialog()">
</ch-cancel-subscription-modal-dialog>

<ch-member-invalid-plan-modal-dialog [show]="showInvalidPlanDialog"
  (onClose)="closeInvalidPlanDialog()"></ch-member-invalid-plan-modal-dialog>

<ch-member-delete-dialog [show]="showMemberDeleteModal" [memberId]="memberId" (onClose)="closeMemberDeleteDialog()">
</ch-member-delete-dialog>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/member/member-edit/member-edit.component.html